import { push } from 'connected-react-router';
import axios from 'axios';
import * as types from './types';
import jwtDecode from 'jwt-decode';

const AUTH_URL_REGISTER = '/api/v1/register/';

const setAuthToken = (token) => {
   if (token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
   } else {
      delete axios.defaults.headers.common['Authorization'];
   }
};

export const registerUser = ({ username, email, phone }, redirect) => {
   return async (dispatch) => {
      try {
         // CSRF
         axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
         axios.defaults.xsrfCookieName = 'csrftoken';

         const { data } = await axios.post(AUTH_URL_REGISTER, { username, email, phone });

         if (data.access && data.refresh) {
            localStorage.setItem('accessToken', data.access);
            localStorage.setItem('refreshToken', data.refresh);
            setAuthToken(data.access);

            dispatch({
               type: types.USER_REGISTER_SUCCESS,
               payload: jwtDecode(data.access),
            });
         } else {
            dispatch({
               type: types.USER_REGISTER_SUCCESS,
               payload: data,
            });
         }

         if (redirect) dispatch(push(redirect));
      } catch (e) {
         dispatch({
            type: types.USER_REGISTER_FAILURE,
            payload: e.response ? e.response.data : e,
         });
         console.log(e.response ? e.response.data : e);
      }
   };
};
